(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ad-product-gallery')) {
    customElements.define('ad-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const slides = [...this.querySelectorAll('[data-gallery-slide]')];
        const buttons = [...this.querySelectorAll('[data-gallery-index]')];
        const counter = this.querySelector('[data-gallery-counter]');
        const select = (index) => {
          slides.forEach((slide, i) => { slide.hidden = i !== index; });
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
          if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
        };
        select(0);
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => select(index));
          button.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = buttons.length - 1;
            else return;
            event.preventDefault();
            select(next);
            buttons[next].focus();
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
